import { EPlatformName, ETelematicsMessagesKeys } from "../types";

export const HELP_URL_BY_PLATFORM = {
  [EPlatformName.GEOTAB]: ETelematicsMessagesKeys.GEOTAB_INSTRUCTIONS_URL,
  [EPlatformName.TRIMBLE]: ETelematicsMessagesKeys.TRIMBLE_INSTRUCTIONS_URL,
  [EPlatformName.WEBFLEET]: ETelematicsMessagesKeys.WEBFLEET_INSTRUCTIONS_URL,
  [EPlatformName.WIALON]: ETelematicsMessagesKeys.WIALON_INSTRUCTIONS_URL,
  [EPlatformName.SAMSARA]: ETelematicsMessagesKeys.SAMSARA_INSTRUCTIONS_URL,
  [EPlatformName.MOTIVE]: ETelematicsMessagesKeys.MOTIVE_INSTRUCTIONS_URL,
  [EPlatformName.AZUGA]: ETelematicsMessagesKeys.AZUGA_INSTRUCTIONS_URL,
  [EPlatformName.AZUGA_ELD]: ETelematicsMessagesKeys.AZUGA_ELD_INSTRUCTIONS_URL,
  [EPlatformName.WORKWAVE]: ETelematicsMessagesKeys.WORKWAVE_INSTRUCTIONS_URL,
  [EPlatformName.VERIZON]: ETelematicsMessagesKeys.VERIZON_INSTRUCTIONS_URL,
  [EPlatformName.GPS_INSIGHT]:
    ETelematicsMessagesKeys.GPS_INSIGHT_INSTRUCTIONS_URL,
  [EPlatformName.WEX_TELEMATICS]:
    ETelematicsMessagesKeys.WEX_TELEMATICS_INSTRUCTIONS_URL,
  [EPlatformName.MIX_TELEMATICS]:
    ETelematicsMessagesKeys.MIXTELEMATICS_INSTRUCTIONS_URL,
  [EPlatformName.EROAD]: ETelematicsMessagesKeys.EROAD_INSTRUCTIONS_URL,
  [EPlatformName.FLEET_COMPLETE]:
    ETelematicsMessagesKeys.FLEET_COMPLETE_INSTRUCTIONS_URL,
  [EPlatformName.TELUS]: ETelematicsMessagesKeys.TELUS_INSTRUCTIONS_URL,
  [EPlatformName.BIGROAD]: ETelematicsMessagesKeys.BIGROAD_INSTRUCTIONS_URL,
  [EPlatformName.LION_EIGHT]:
    ETelematicsMessagesKeys.LION_EIGHT_INSTRUCTIONS_URL,
  [EPlatformName.LYTX]: ETelematicsMessagesKeys.LYTX_INSTRUCTIONS_URL,
  [EPlatformName.OMNITRACS]: ETelematicsMessagesKeys.OMNITRACS_INSTRUCTIONS_URL,
  [EPlatformName.ISAAC]: ETelematicsMessagesKeys.ISAAC_INSTRUCTIONS_URL,
  [EPlatformName.NETRADYNE]: ETelematicsMessagesKeys.NETRADYNE_INSTRUCTIONS_URL,
  [EPlatformName.NEXTRAQ]: ETelematicsMessagesKeys.NEXTRAQ_INSTRUCTIONS_URL,
  [EPlatformName.ONE_STEP_GPS]:
    ETelematicsMessagesKeys.ONE_STEP_GPS_INSTRUCTIONS_URL,
  [EPlatformName.FLEETLOCATE_SPIREON_NSPIRE]:
    ETelematicsMessagesKeys.FLEET_LOCATE_SPIREON_INSTRUCTIONS_URL,
  [EPlatformName.XRS]: ETelematicsMessagesKeys.XRS_INSTRUCTIONS_URL,
  [EPlatformName.ZONAR]: ETelematicsMessagesKeys.ZONAR_SYSTEMS_INSTRUCTIONS_URL,
  [EPlatformName.ORBCOMM_ELD]:
    ETelematicsMessagesKeys.ORBCOMM_ELD_INSTRUCTIONS_URL,
  [EPlatformName.ORBCOMM_BLUE_TREE]:
    ETelematicsMessagesKeys.ORBCOMM_BLUE_TREE_INSTRUCTIONS_URL,
  [EPlatformName.VISION_TRACK]:
    ETelematicsMessagesKeys.VISION_TRACK_INSTRUCTIONS_URL,
  [EPlatformName.WAYLENS]: ETelematicsMessagesKeys.WAYLENS_INSTRUCTIONS_URL,
  [EPlatformName.INSIGHT_MOBILE_DATA]:
    ETelematicsMessagesKeys.INSIGHT_MOBILE_DATA_INSTRUCTIONS_URL,
  [EPlatformName.MONARCH_GPS]:
    ETelematicsMessagesKeys.MONARCH_GPS_INSTRUCTIONS_URL,
  [EPlatformName.RHINO]: ETelematicsMessagesKeys.RHINO_INSTRUCTIONS_URL,
  [EPlatformName.TOUCHTEL_GPS]:
    ETelematicsMessagesKeys.TOUCHTEL_GPS_INSTRUCTIONS_URL,
  [EPlatformName.TRUCKSPY]: ETelematicsMessagesKeys.TRUCKSPY_INSTRUCTIONS_URL,
  [EPlatformName.GPS_COMMANDER]:
    ETelematicsMessagesKeys.GPS_COMMANDER_INSTRUCTIONS_URL,
  [EPlatformName.ATNT_FLEET_COMPLETE]:
    ETelematicsMessagesKeys.ATNT_FLEET_COMPLETE_INSTRUCTIONS_URL,
  [EPlatformName.FLEET_UP]: ETelematicsMessagesKeys.FLEET_UP_INSTRUCTIONS_URL,
  [EPlatformName.ACTSOFT_ENCORE]:
    ETelematicsMessagesKeys.ACTSOFT_ENCORE_INSTRUCTIONS_URL,
  [EPlatformName.ADVANTAGE_ASSET_TRACKING]:
    ETelematicsMessagesKeys.ADVANTAGE_ASSET_TRACKING_INSTRUCTIONS_URL,
  [EPlatformName.ARGOS_CONNECTED_SOLUTIONS]:
    ETelematicsMessagesKeys.ARGOS_CONNECTED_SOLUTIONS_INSTRUCTIONS_URL,
  [EPlatformName.ARI_FLEET]: ETelematicsMessagesKeys.ARI_FLEET_INSTRUCTIONS_URL,
  [EPlatformName.ASSURED_TELEMATICS]:
    ETelematicsMessagesKeys.ASSURED_TELEMATICS_INSTRUCTIONS_URL,
  [EPlatformName.ATNT_FLEET]:
    ETelematicsMessagesKeys.ATNT_FLEET_INSTRUCTIONS_URL,
  [EPlatformName.ATTRIX]: ETelematicsMessagesKeys.ATTRIX_INSTRUCTIONS_URL,
  [EPlatformName.BADGER_FLEET_SOLUTIONS]:
    ETelematicsMessagesKeys.BADGER_FLEET_SOLUTIONS_INSTRUCTIONS_URL,
  [EPlatformName.BAR_CODING_CANADA]:
    ETelematicsMessagesKeys.BAR_CODING_CANADA_INSTRUCTIONS_URL,
  [EPlatformName.BLUEARROW]: ETelematicsMessagesKeys.BLUEARROW_INSTRUCTIONS_URL,
  [EPlatformName.CARRIERHQ]: ETelematicsMessagesKeys.CARRIERHQ_INSTRUCTIONS_URL,
  [EPlatformName.ENVUE_TELEMATICS]:
    ETelematicsMessagesKeys.ENVUE_TELEMATICS_INSTRUCTIONS_URL,
  [EPlatformName.FLEET_NAV_SYSTEMS]:
    ETelematicsMessagesKeys.FLEET_NAV_SYSTEMS_INSTRUCTIONS_URL,
  [EPlatformName.FLEET_PROFIT_CENTER]:
    ETelematicsMessagesKeys.FLEET_PROFIT_CENTER_INSTRUCTIONS_URL,
  [EPlatformName.FLEETBOSS_GPS]:
    ETelematicsMessagesKeys.FLEETBOSS_GPS_INSTRUCTIONS_URL,
  [EPlatformName.FLEETHOSTER]:
    ETelematicsMessagesKeys.FLEETHOSTER_INSTRUCTIONS_URL,
  [EPlatformName.FLEETISTICS]:
    ETelematicsMessagesKeys.FLEETISTICS_INSTRUCTIONS_URL,
  [EPlatformName.FLEETLOCATE_GEOTAB]:
    ETelematicsMessagesKeys.FLEETLOCATE_GEOTAB_INSTRUCTIONS_URL,
  [EPlatformName.FLEETMASTER]:
    ETelematicsMessagesKeys.FLEETMASTER_INSTRUCTIONS_URL,
  [EPlatformName.FLEXPORT]: ETelematicsMessagesKeys.FLEXPORT_INSTRUCTIONS_URL,
  [EPlatformName.GEOFORCE]: ETelematicsMessagesKeys.GEOFORCE_INSTRUCTIONS_URL,
  [EPlatformName.GLOSTONE]: ETelematicsMessagesKeys.GLOSTONE_INSTRUCTIONS_URL,
  [EPlatformName.GOFLEET]: ETelematicsMessagesKeys.GOFLEET_INSTRUCTIONS_URL,
  [EPlatformName.GOGPS]: ETelematicsMessagesKeys.GOGPS_INSTRUCTIONS_URL,
  [EPlatformName.GPS_FLEET_FINDER]:
    ETelematicsMessagesKeys.GPS_FLEET_FINDER_INSTRUCTIONS_URL,
  [EPlatformName.GPS_SOLUTIONS]:
    ETelematicsMessagesKeys.GPS_SOLUTIONS_INSTRUCTIONS_URL,
  [EPlatformName.GPS_TRACKING_CANADA]:
    ETelematicsMessagesKeys.GPS_TRACKING_CANADA_INSTRUCTIONS_URL,
  [EPlatformName.GRAYBOX_SOLUTIONS]:
    ETelematicsMessagesKeys.GRAYBOX_SOLUTIONS_INSTRUCTIONS_URL,
  [EPlatformName.GRIDLINE]: ETelematicsMessagesKeys.GRIDLINE_INSTRUCTIONS_URL,
  [EPlatformName.HIGHPOINT_GPS]:
    ETelematicsMessagesKeys.HIGHPOINT_GPS_INSTRUCTIONS_URL,
  [EPlatformName.IOTAB]: ETelematicsMessagesKeys.IOTAB_INSTRUCTIONS_URL,
  [EPlatformName.LYNX]: ETelematicsMessagesKeys.LYNX_INSTRUCTIONS_URL,
  [EPlatformName.ONTRAK_SOLUTIONS]:
    ETelematicsMessagesKeys.ONTRAK_SOLUTIONS_INSTRUCTIONS_URL,
  [EPlatformName.PENSKE]: ETelematicsMessagesKeys.PENSKE_INSTRUCTIONS_URL,
  [EPlatformName.PREPASS_ELD]:
    ETelematicsMessagesKeys.PREPASS_ELD_INSTRUCTIONS_URL,
  [EPlatformName.QUALITY_GPS]:
    ETelematicsMessagesKeys.QUALITY_GPS_INSTRUCTIONS_URL,
  [EPlatformName.RMJ_TECHNOLOGIES]:
    ETelematicsMessagesKeys.RMJ_TECHNOLOGIES_INSTRUCTIONS_URL,
  [EPlatformName.RUSH_ENTERPRISES]:
    ETelematicsMessagesKeys.RUSH_ENTERPRISES_INSTRUCTIONS_URL,
  [EPlatformName.RYDER]: ETelematicsMessagesKeys.RYDER_INSTRUCTIONS_URL,
  [EPlatformName.SAFETY_VISION]:
    ETelematicsMessagesKeys.SAFETY_VISION_INSTRUCTIONS_URL,
  [EPlatformName.SHELL_TELEMATICS]:
    ETelematicsMessagesKeys.SHELL_TELEMATICS_INSTRUCTIONS_URL,
  [EPlatformName.SURECAM]: ETelematicsMessagesKeys.SURECAM_INSTRUCTIONS_URL,
  [EPlatformName.T_MOBILE]: ETelematicsMessagesKeys.T_MOBILE_INSTRUCTIONS_URL,
  [EPlatformName.TRANSFLO]: ETelematicsMessagesKeys.TRANSFLO_INSTRUCTIONS_URL,
  [EPlatformName.TRAXXISGPS]:
    ETelematicsMessagesKeys.TRAXXISGPS_INSTRUCTIONS_URL,
  [EPlatformName.VERTRAX]: ETelematicsMessagesKeys.VERTRAX_INSTRUCTIONS_URL,
  [EPlatformName.ZENDUIT]: ETelematicsMessagesKeys.ZENDUIT_INSTRUCTIONS_URL,
  [EPlatformName.ADVANTAGE_ONE]:
    ETelematicsMessagesKeys.ADVANTAGE_ONE_INSTRUCTIONS_URL,
  [EPlatformName.EAGLE_WIRELESS]:
    ETelematicsMessagesKeys.EAGLE_WIRELESS_INSTRUCTIONS_URL,
  [EPlatformName.HOLMAN]: ETelematicsMessagesKeys.HOLMAN_INSTRUCTIONS_URL,
  [EPlatformName.ENTERPRISE_FLEET_MANAGEMENT]:
    ETelematicsMessagesKeys.ENTERPRISE_FLEET_MANAGEMENT_INSTRUCTIONS_URL,
  [EPlatformName.DICAN]: ETelematicsMessagesKeys.DICAN_INSTRUCTIONS_URL,
  [EPlatformName.LINXUP]: ETelematicsMessagesKeys.LINXUP_INSTRUCTIONS_URL,
  [EPlatformName.AWARE_GPS]: ETelematicsMessagesKeys.AWARE_GPS_INSTRUCTIONS_URL,
  [EPlatformName.COMMAND_GPS]:
    ETelematicsMessagesKeys.COMMAND_GPS_INSTRUCTIONS_URL,
  [EPlatformName.FLEETSHARP]:
    ETelematicsMessagesKeys.FLEETSHARP_INSTRUCTIONS_URL,
  [EPlatformName.ELD_RIDER_PRO]:
    ETelematicsMessagesKeys.ELD_RIDER_PRO_INSTRUCTIONS_URL,
  [EPlatformName.SHELD]: ETelematicsMessagesKeys.SHELD_INSTRUCTIONS_URL,
  [EPlatformName.XELD]: ETelematicsMessagesKeys.XELD_INSTRUCTIONS_URL,
  [EPlatformName.ZELD]: ETelematicsMessagesKeys.ZELD_INSTRUCTIONS_URL,
  [EPlatformName.EVA_ELD]: ETelematicsMessagesKeys.EVA_ELD_INSTRUCTIONS_URL,
  [EPlatformName.XPLORE_ELD]:
    ETelematicsMessagesKeys.XPLORE_ELD_INSTRUCTIONS_URL,
  [EPlatformName.OPTIMA_ELD]:
    ETelematicsMessagesKeys.OPTIMA_ELD_INSTRUCTIONS_URL,
  [EPlatformName.PRO_RIDE_ELD]:
    ETelematicsMessagesKeys.PRO_RIDE_ELD_INSTRUCTIONS_URL,
  [EPlatformName.REQUEST]: ETelematicsMessagesKeys.REQUEST_INSTRUCTIONS_URL,
  [EPlatformName.TELETRAC_NAVMAN]:
    ETelematicsMessagesKeys.TELETRAC_NAVMAN_INSTRUCTIONS_URL,
  [EPlatformName.GORILLA_SAFETY]:
    ETelematicsMessagesKeys.GORILLA_SAFETY_INSTRUCTIONS_URL,
  [EPlatformName.CLUTCH_ELD]:
    ETelematicsMessagesKeys.CLUTCH_ELD_INSTRUCTIONS_URL,
  [EPlatformName.CYNTRX_ELD_PLUS]:
    ETelematicsMessagesKeys.CYNTRX_ELD_PLUS_INSTRUCTIONS_URL,
  [EPlatformName.ELD_MANDATE_PRO]:
    ETelematicsMessagesKeys.ELD_MANDATE_PRO_INSTRUCTIONS_URL,
  // [EPlatformName.FLEET_LOCATE_ELD]:
  //   ETelematicsMessagesKeys.FLEET_LOCATE_ELD_INSTRUCTIONS_URL,
  [EPlatformName.PATRIOT]: ETelematicsMessagesKeys.PATRIOT_INSTRUCTIONS_URL,
  [EPlatformName.SIMPLEX_ELD]:
    ETelematicsMessagesKeys.SIMPLEX_ELD_INSTRUCTIONS_URL,
  [EPlatformName.TRACK_ON_ELD]:
    ETelematicsMessagesKeys.TRACK_ON_ELD_INSTRUCTIONS_URL,
  [EPlatformName.TRUCKER_PATH_ELD_PRO]:
    ETelematicsMessagesKeys.TRUCKER_PATH_ELD_PRO_INSTRUCTIONS_URL,
  [EPlatformName.INTELLISHIFT]:
    ETelematicsMessagesKeys.INTELLISHIFT_INSTRUCTIONS_URL,
  [EPlatformName.EZ_FLEET]: ETelematicsMessagesKeys.EZ_FLEET_INSTRUCTIONS_URL,
  [EPlatformName.SIMPLE_TRUCK_ELD]:
    ETelematicsMessagesKeys.SIMPLE_TRUCK_ELD_INSTRUCTIONS_URL,
  [EPlatformName.GLOBAL_ELD]:
    ETelematicsMessagesKeys.GLOBAL_ELD_INSTRUCTIONS_URL,
  [EPlatformName.SIMPLE_E_LOG]:
    ETelematicsMessagesKeys.SIMPLE_E_LOG_INSTRUCTIONS_URL,
  [EPlatformName.MICHELIN_CONNECTED_FLEET]:
    ETelematicsMessagesKeys.MICHELIN_CONNECTED_FLEET_INSTRUCTIONS_URL,
  [EPlatformName.GPS_TRACKIT]:
    ETelematicsMessagesKeys.GPS_TRACKIT_INSTRUCTIONS_URL,
  [EPlatformName.BRICKHOUSE_SECURITY]:
    ETelematicsMessagesKeys.BRICKHOUSE_SECURITY_INSTRUCTIONS_URL,
  [EPlatformName.TERMINUS_GPS_ELD]:
    ETelematicsMessagesKeys.WIALON_INSTRUCTIONS_URL,
  [EPlatformName.BRANIX]: ETelematicsMessagesKeys.WIALON_INSTRUCTIONS_URL,
  [EPlatformName.BLUE_INK]:
    ETelematicsMessagesKeys.BLUEINK_TECH_INSTRUCTIONS_URL,
  [EPlatformName.TX_ELD]: ETelematicsMessagesKeys.TX_ELD_INSTRUCTIONS_URL,
  [EPlatformName.POP_ELD]: ETelematicsMessagesKeys.POP_ELD_INSTRUCTIONS_URL,
  [EPlatformName.NEXTRAQ_MARCUS]:
    ETelematicsMessagesKeys.NEXTRAQ_MARCUS_INSTRUCTIONS_URL,
  [EPlatformName.PEAK_ELD]: ETelematicsMessagesKeys.PEAK_ELD_INSTRUCTIONS_URL,
  // HOS Connect resellers
  [EPlatformName.HOS_247]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.BLACK_BEAR_ELD]:
    ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.COLUMBUS_ELD]:
    ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.STATE_ELOG]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.DY_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName._3PL_TEK]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.ABC_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.ACTION_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.ADVANTAGE_KNIGHTS_ELD]:
    ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.ALPHA_E_LOGBOOK]:
    ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.AMPM_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.BISON_ELOG]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.CAPTAIN_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.COBRA_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.DAILY_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.DFL_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.DIGITAL_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.DLOG_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.DYNAMIC_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.EGREEN_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.ELD_FOR_YOU]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.ELD2GO]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.ELD4TRUCKING]:
    ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.ELOG42]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.EXTREME_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.FLASH_ELOGS]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.GLOBCOM_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.HERO_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.INFINITY_ELD]:
    ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.IRONMAN_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.JUST_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.LEGACY_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.LOG_PLUS_ELD]:
    ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.MOONLIGHT_ELD]:
    ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.NOOR_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.NOVIO_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.ORIENT_STAR_ELD]:
    ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.PARAGON_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.PHOENIX_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.PIONEER_ELD_SOLUTION]:
    ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.POWERTRUCKS_ELD]:
    ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.PROJECT_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.QUICK_ELOGS_ELD]:
    ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.RENAISSANCE_ELD]:
    ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.ROBINHOOD_ELD]:
    ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.ROUTE_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.RUN_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.SBA_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.SF_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.SIMBA_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.SMART_CHOICE_LOGS]:
    ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.SPEEDLINE_ELD]:
    ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.STARWAY_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.SUPPORT_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.TEDDY_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.TEMPUS_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.TRUE_ROAD_ELD]:
    ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.TRUST_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.UNDER_CONTROL_ELD]:
    ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.UNITY_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.VLOG_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.XPERT_LOGS]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.YOULOG_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.ZAPHIRA_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.EBLUE_SUN_LOGS]:
    ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.ELD_DESIRED]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.FIRSTGATE_ELD]:
    ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.GRAND_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.ILOG_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.PLATINUM_ELD]:
    ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.READYSETPIPE_ELD]:
    ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.RED_FOX_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.REGULOG_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.SUBSET_LOGBOOK]:
    ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.UNIQUE_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.TOP_COMPLIANCE_ELD]:
    ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.OMEGA_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  // GPSTAB resellers
  [EPlatformName.GPSTAB]: ETelematicsMessagesKeys.GPSTAB_INSTRUCTIONS_URL,
  [EPlatformName.MAX_ELD]: ETelematicsMessagesKeys.GPSTAB_INSTRUCTIONS_URL,
  [EPlatformName.MOUNTAIN_ELD]: ETelematicsMessagesKeys.GPSTAB_INSTRUCTIONS_URL,
  [EPlatformName.ELD_ONE]: ETelematicsMessagesKeys.GPSTAB_INSTRUCTIONS_URL,
  [EPlatformName.ROADSTAR_ELD]: ETelematicsMessagesKeys.GPSTAB_INSTRUCTIONS_URL,
  [EPlatformName.MASTER_ELD]: ETelematicsMessagesKeys.GPSTAB_INSTRUCTIONS_URL,
  [EPlatformName.REAL_ELD]: ETelematicsMessagesKeys.GPSTAB_INSTRUCTIONS_URL,
  [EPlatformName.TFM_ELD]: ETelematicsMessagesKeys.GPSTAB_INSTRUCTIONS_URL,
  [EPlatformName.FM_ELD]: ETelematicsMessagesKeys.GPSTAB_INSTRUCTIONS_URL,
  [EPlatformName.LIGHT_AND_TRAVEL_ELD]:
    ETelematicsMessagesKeys.GPSTAB_INSTRUCTIONS_URL,
  [EPlatformName.ID_ELD]: ETelematicsMessagesKeys.GPSTAB_INSTRUCTIONS_URL,
  [EPlatformName.NEO_ELD]: ETelematicsMessagesKeys.GPSTAB_INSTRUCTIONS_URL,
  [EPlatformName.COGO_ELD]: ETelematicsMessagesKeys.GPSTAB_INSTRUCTIONS_URL,
  [EPlatformName.DIALOG_ELD]: ETelematicsMessagesKeys.GPSTAB_INSTRUCTIONS_URL,
  [EPlatformName.MATRACK]: ETelematicsMessagesKeys.MATRACK_INSTRUCTIONS_URL,
  [EPlatformName.VESTIGE]:
    ETelematicsMessagesKeys.VESTIGE_VIEW_INSTRUCTIONS_URL,
  [EPlatformName.GTS]: ETelematicsMessagesKeys.GTS_INSTRUCTIONS_URL,
  // Reseller batch additions
  [EPlatformName.ELITEGPS]: ETelematicsMessagesKeys.ELITEGPS_INSTRUCTIONS_URL,
  [EPlatformName.INTOUCH_GPS]:
    ETelematicsMessagesKeys.INTOUCH_GPS_INSTRUCTIONS_URL,
  [EPlatformName.SPARKLE_ELD]:
    ETelematicsMessagesKeys.SPARKLE_ELD_INSTRUCTIONS_URL,
  [EPlatformName.APEX_ELD]: ETelematicsMessagesKeys.APEX_ELD_INSTRUCTIONS_URL,
  [EPlatformName.ROCK_ELD]: ETelematicsMessagesKeys.ROCK_ELD_INSTRUCTIONS_URL,
  [EPlatformName.RIDEHUB_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.TRACK_TRUCK]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.TRUCKSTAFF_ELD]:
    ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.DRAGON_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.FLEX_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.HIGHEST_GEARS]:
    ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.PDSYNC_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.TRUCK_FORD_ELD]:
    ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.ASAP_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.EXTENDED_ROAD_ELD]:
    ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.AUTOGRI_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.AVANGUARD_ELD]:
    ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.AXIOS_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.BELLFAM_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.BEST_SOURCE_ELD]:
    ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.BOLT_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.DOCUDRIVE_ELD]:
    ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.RING_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.EXPRESS_WAY_ELD]:
    ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.LOOKTRUCK_ELD]:
    ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.RS_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.VRH_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.LOGS_SKI_ELD]:
    ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.TURNSBUSS]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.PREMIERRIDE_LOGS]:
    ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.SIMPLEWAY_ELD]:
    ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.OZOD_EXPRESS_ELD]:
    ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.MAP_ELOG]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.AM_LOGS_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName._48_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.ROYAL_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.INSPIRE_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.SPLIT_ELD]: ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  [EPlatformName.ELD_ROAD_HOS]:
    ETelematicsMessagesKeys.HOS_247_INSTRUCTIONS_URL,
  // Trackensure resellers
  [EPlatformName.TRACKENSURE]:
    ETelematicsMessagesKeys.TRACKENSURE_INSTRUCTIONS_URL,
  [EPlatformName.SWIFT_ELD]:
    ETelematicsMessagesKeys.TRACKENSURE_INSTRUCTIONS_URL,
  [EPlatformName.SWITCHBOARD]:
    ETelematicsMessagesKeys.SWITCHBOARD_INSTRUCTIONS_URL,
  [EPlatformName.AMBER_ELD]:
    ETelematicsMessagesKeys.TRACKENSURE_INSTRUCTIONS_URL,
  [EPlatformName.CLUB_ELD]:
    ETelematicsMessagesKeys.TRACKENSURE_INSTRUCTIONS_URL,
  [EPlatformName.ELD_PRO_SOLUTION]:
    ETelematicsMessagesKeys.TRACKENSURE_INSTRUCTIONS_URL,
  [EPlatformName.PROTRACKING_ELD]:
    ETelematicsMessagesKeys.TRACKENSURE_INSTRUCTIONS_URL,
  [EPlatformName.SHARP_ELD]:
    ETelematicsMessagesKeys.TRACKENSURE_INSTRUCTIONS_URL,
  [EPlatformName.VISTA_ELD]:
    ETelematicsMessagesKeys.TRACKENSURE_INSTRUCTIONS_URL,
  [EPlatformName.ZENITH_ELD]:
    ETelematicsMessagesKeys.TRACKENSURE_INSTRUCTIONS_URL,
  [EPlatformName.ADA_ELD]: ETelematicsMessagesKeys.TRACKENSURE_INSTRUCTIONS_URL,
  [EPlatformName.ALFA_ELD]:
    ETelematicsMessagesKeys.TRACKENSURE_INSTRUCTIONS_URL,
  [EPlatformName.ENSI_LOG]:
    ETelematicsMessagesKeys.TRACKENSURE_INSTRUCTIONS_URL,
  [EPlatformName.INTERSTATE_FREEWAY]:
    ETelematicsMessagesKeys.TRACKENSURE_INSTRUCTIONS_URL,
  [EPlatformName.SMART_ELOG]:
    ETelematicsMessagesKeys.TRACKENSURE_INSTRUCTIONS_URL,
  [EPlatformName.SPRINT_ELD]:
    ETelematicsMessagesKeys.TRACKENSURE_INSTRUCTIONS_URL,
  [EPlatformName.TRIP_ELD]:
    ETelematicsMessagesKeys.TRACKENSURE_INSTRUCTIONS_URL,
  [EPlatformName._24HOS_ELD]:
    ETelematicsMessagesKeys.TRACKENSURE_INSTRUCTIONS_URL,
  [EPlatformName.FORTUNE_ELD]:
    ETelematicsMessagesKeys.TRACKENSURE_INSTRUCTIONS_URL,
  [EPlatformName.ORION_ELD]:
    ETelematicsMessagesKeys.TRACKENSURE_INSTRUCTIONS_URL,
  [EPlatformName.PHANTOM_ELD]:
    ETelematicsMessagesKeys.TRACKENSURE_INSTRUCTIONS_URL,
  [EPlatformName.TRENDY_ELD]:
    ETelematicsMessagesKeys.TRACKENSURE_INSTRUCTIONS_URL,
  [EPlatformName.VECTOR_ELD]:
    ETelematicsMessagesKeys.TRACKENSURE_INSTRUCTIONS_URL,
  [EPlatformName.WHEELS_ELOG]:
    ETelematicsMessagesKeys.TRACKENSURE_INSTRUCTIONS_URL,
  [EPlatformName.FLEETHUNT]: ETelematicsMessagesKeys.FLEETHUNT_INSTRUCTIONS_URL,
  [EPlatformName.VOYOMOTIVE]:
    ETelematicsMessagesKeys.VOYOMOTIVE_INSTRUCTIONS_URL,
  // Reliable ELD resellers
  [EPlatformName.RELIABLE_ELD]:
    ETelematicsMessagesKeys.RELIABLEELD_INSTRUCTIONS_URL,
  [EPlatformName.AT_ELD]: ETelematicsMessagesKeys.RELIABLEELD_INSTRUCTIONS_URL,
  [EPlatformName.MGK_ELD]: ETelematicsMessagesKeys.RELIABLEELD_INSTRUCTIONS_URL,
  [EPlatformName.NOOR_ELD_SOLUTION]:
    ETelematicsMessagesKeys.RELIABLEELD_INSTRUCTIONS_URL,
  [EPlatformName.ORIENT_ELD]:
    ETelematicsMessagesKeys.RELIABLEELD_INSTRUCTIONS_URL,
  [EPlatformName.AXION_ROUTE]:
    ETelematicsMessagesKeys.RELIABLEELD_INSTRUCTIONS_URL,
  // TT ELD resellers - shared instruction key
  [EPlatformName.TT_ELD]: ETelematicsMessagesKeys.TT_ELD_INSTRUCTIONS_URL,
  [EPlatformName.EVO_ELD]: ETelematicsMessagesKeys.TT_ELD_INSTRUCTIONS_URL,
  [EPlatformName.ONTIME_LOGS]: ETelematicsMessagesKeys.TT_ELD_INSTRUCTIONS_URL,
  [EPlatformName.ZIPPY_ELD]: ETelematicsMessagesKeys.TT_ELD_INSTRUCTIONS_URL,
  [EPlatformName.ONTIME_ELD]: ETelematicsMessagesKeys.TT_ELD_INSTRUCTIONS_URL,
  [EPlatformName.FIVE_ELD]: ETelematicsMessagesKeys.TT_ELD_INSTRUCTIONS_URL,
  [EPlatformName.LOGFLEET_ELD]: ETelematicsMessagesKeys.TT_ELD_INSTRUCTIONS_URL,
  [EPlatformName.SUN_ELD]: ETelematicsMessagesKeys.TT_ELD_INSTRUCTIONS_URL,
  [EPlatformName.FLEET_VISION]: ETelematicsMessagesKeys.TT_ELD_INSTRUCTIONS_URL,
  // Drive HOS resellers
  [EPlatformName.DRIVE_HOS]: ETelematicsMessagesKeys.DRIVEHOS_INSTRUCTIONS_URL,
  [EPlatformName.FACTOR_ELD]: ETelematicsMessagesKeys.DRIVEHOS_INSTRUCTIONS_URL,
  [EPlatformName.DAILY_ELD_PLUS]:
    ETelematicsMessagesKeys.DRIVEHOS_INSTRUCTIONS_URL,
  [EPlatformName.DSG_LOGS]: ETelematicsMessagesKeys.DRIVEHOS_INSTRUCTIONS_URL,
  [EPlatformName.DY_PLUS_ELD]:
    ETelematicsMessagesKeys.DRIVEHOS_INSTRUCTIONS_URL,
  [EPlatformName.EGREEN_ELD_PRO]:
    ETelematicsMessagesKeys.DRIVEHOS_INSTRUCTIONS_URL,
  [EPlatformName.UZBPRIME_ELD]:
    ETelematicsMessagesKeys.DRIVEHOS_INSTRUCTIONS_URL,
  [EPlatformName.ILOG_ELD_APP]:
    ETelematicsMessagesKeys.DRIVEHOS_INSTRUCTIONS_URL,
  [EPlatformName.LEADER_ELD]: ETelematicsMessagesKeys.DRIVEHOS_INSTRUCTIONS_URL,
  [EPlatformName.LUCID_ELD]: ETelematicsMessagesKeys.DRIVEHOS_INSTRUCTIONS_URL,
  [EPlatformName.PANDA_ELD]: ETelematicsMessagesKeys.DRIVEHOS_INSTRUCTIONS_URL,
  [EPlatformName.PRESTIGE_ELD]:
    ETelematicsMessagesKeys.DRIVEHOS_INSTRUCTIONS_URL,
  [EPlatformName.STARTRUCKS_ELD]:
    ETelematicsMessagesKeys.DRIVEHOS_INSTRUCTIONS_URL,
  [EPlatformName.US_FAST_ELD]:
    ETelematicsMessagesKeys.DRIVEHOS_INSTRUCTIONS_URL,
  [EPlatformName.US_POWER_ELD]:
    ETelematicsMessagesKeys.DRIVEHOS_INSTRUCTIONS_URL,
  [EPlatformName.VITALITY_ELD]:
    ETelematicsMessagesKeys.DRIVEHOS_INSTRUCTIONS_URL,
  [EPlatformName.ZEROMAX_ELD]:
    ETelematicsMessagesKeys.DRIVEHOS_INSTRUCTIONS_URL,
  [EPlatformName.BLUE_STAR_ELD]:
    ETelematicsMessagesKeys.DRIVEHOS_INSTRUCTIONS_URL,
  [EPlatformName.SECURE_PATH_ELD]:
    ETelematicsMessagesKeys.DRIVEHOS_INSTRUCTIONS_URL,
  [EPlatformName.FIRST_ELD]: ETelematicsMessagesKeys.DRIVEHOS_INSTRUCTIONS_URL,
  [EPlatformName.DRIVE_LENS_ELD]:
    ETelematicsMessagesKeys.DRIVEHOS_INSTRUCTIONS_URL,
  [EPlatformName.NIGHT_WATCH_ELD]:
    ETelematicsMessagesKeys.DRIVEHOS_INSTRUCTIONS_URL,
  [EPlatformName._ELD88]: ETelematicsMessagesKeys.DRIVEHOS_INSTRUCTIONS_URL,
  [EPlatformName.AFS_WORLD_ELD]:
    ETelematicsMessagesKeys.DRIVEHOS_INSTRUCTIONS_URL,
  [EPlatformName.HUNTER_ELD]: ETelematicsMessagesKeys.DRIVEHOS_INSTRUCTIONS_URL,
  [EPlatformName.REMAX_ELD]: ETelematicsMessagesKeys.DRIVEHOS_INSTRUCTIONS_URL,
  // EzToTrack resellers - shared instruction key
  [EPlatformName.EZ_TO_TRACK]:
    ETelematicsMessagesKeys.EZTOTRACK_INSTRUCTIONS_URL,
  [EPlatformName.GOOD_DEAL_GPS]:
    ETelematicsMessagesKeys.EZTOTRACK_INSTRUCTIONS_URL,
  [EPlatformName.HOS_ELD]: ETelematicsMessagesKeys.EZTOTRACK_INSTRUCTIONS_URL,
  [EPlatformName.TRANSIT_TRACKING]:
    ETelematicsMessagesKeys.EZTOTRACK_INSTRUCTIONS_URL,
  [EPlatformName.MT_ELD]: ETelematicsMessagesKeys.EZTOTRACK_INSTRUCTIONS_URL,
  [EPlatformName.EAGLE_ELD]: ETelematicsMessagesKeys.EZTOTRACK_INSTRUCTIONS_URL,
  [EPlatformName.SMART_WAY_ELD]:
    ETelematicsMessagesKeys.EZTOTRACK_INSTRUCTIONS_URL,
  [EPlatformName.OXEMON]: ETelematicsMessagesKeys.EZTOTRACK_INSTRUCTIONS_URL,
  [EPlatformName.ROUTELINK_IO]:
    ETelematicsMessagesKeys.EZTOTRACK_INSTRUCTIONS_URL,
  [EPlatformName.ELD4_TRUCKS]:
    ETelematicsMessagesKeys.EZTOTRACK_INSTRUCTIONS_URL,
  [EPlatformName.ATINA_ELD]: ETelematicsMessagesKeys.EZTOTRACK_INSTRUCTIONS_URL,
  [EPlatformName.UNIFY_ELD]: ETelematicsMessagesKeys.EZTOTRACK_INSTRUCTIONS_URL,
  [EPlatformName.ELD_RUN]: ETelematicsMessagesKeys.EZTOTRACK_INSTRUCTIONS_URL,
  [EPlatformName.TERA_HUB]: ETelematicsMessagesKeys.EZTOTRACK_INSTRUCTIONS_URL,
  [EPlatformName.HOBBS_ELD]: ETelematicsMessagesKeys.EZTOTRACK_INSTRUCTIONS_URL,
  [EPlatformName.PINNACLE_ELD]:
    ETelematicsMessagesKeys.EZTOTRACK_INSTRUCTIONS_URL,
  [EPlatformName.MEMENTO_ELD]:
    ETelematicsMessagesKeys.EZTOTRACK_INSTRUCTIONS_URL,
  [EPlatformName.HORIZONT_PATH_ELD]:
    ETelematicsMessagesKeys.EZTOTRACK_INSTRUCTIONS_URL,
  [EPlatformName.NOMAD_ELD]: ETelematicsMessagesKeys.EZTOTRACK_INSTRUCTIONS_URL,
  [EPlatformName.TXT_ELD]: ETelematicsMessagesKeys.TXT_ELD_INSTRUCTIONS_URL,
  [EPlatformName.PAYD_ELD]: ETelematicsMessagesKeys.PAYD_ELD_INSTRUCTIONS_URL,
  [EPlatformName.HUTCH_SYSTEMS]:
    ETelematicsMessagesKeys.HUTCH_SYSTEMS_INSTRUCTIONS_URL,
};
